import React, { Component } from 'react';
import fetch from '../../support/fetch';
import AuthenticatedTemplate from "../../Components/Templates/Authenticated/index";
import { Card, Grid, Dimmer, Form, Button } from 'tabler-react';
import Input from '../../Components/Playgrond/Input';
import CardAlert from '../../Components/CardAlert';

class ChangeAddress extends Component {
    state = {
        showLoader: false,
        alertText: '',
        alertColor: 'danger',
        user: {},
        values: {}
    };

    

    componentDidMount() {
        this.setState({
            user: JSON.parse(sessionStorage.getItem('ooppah_user_info'))
        })
    };

    onChangeHandler = e => {
        const { name, value } = e.target;
        this.setState(prevState => ({
            values: {
                ...prevState.values,
                [name]: value
            }
        }))
    };

    submitHandler = e => {
        e.preventDefault();

        this.setState({showLoader: true});

        fetch.obj({
            query: `mutation changeAddress($zipcode: String, $street: String, $number: String, $complement: String, $district: String, $city: String, $state: String) {
                changeAddress(zipcode: $zipcode, street: $street, number: $number, complement: $complement, district: $district, city: $city, state: $state) {
                    zipCode
                    street
                    number
                    complement
                    district
                    city
                    state
                }
            }`,
            variables: {
                zipcode: this.state.values.zipcode || null,
                street: this.state.values.address || null,
                number: this.state.values.number || null,
                complement: this.state.values.complement || null,
                district: this.state.values.district || null,
                city: this.state.values.city || null,
                state: this.state.values.state || null,
            }
        })
        .then(res => {
            if (res.hasOwnProperty('errors') && res.errors[0].hasOwnProperty('validation')) {
                const lastErrorKey = Object.keys(res.errors[0].validation)[0];

                this.setState({
                    alertText: res.errors[0].validation[lastErrorKey][0]
                })
            }

            this.setState(prevState => ({
                user: {
                    ...prevState.user,
                    address: res.data.changeAddress
                }
            }), () => {
                sessionStorage.setItem('ooppah_user_info', JSON.stringify(this.state.user));
                window.location = '/home'
            });

            this.setState({showLoader: false});
        });
    };

    render() {
        
        let currentAddress = {
            'street':'',
            'number':'',
            'complement':'',
            'state':'',
            'city':'',
            'district':'',
            'zipCode':'',
        };
        if (this.state.user) {
            const currentStateAddress = this.state.user.address;
            const tempObj = {}
            currentAddress = Object.assign(tempObj, currentStateAddress);
        }

        const options = [
            {
                label: "AC",
                value: "AC",
            },
            {
                label: "AL",
                value: "AL",
            },
            {
                label: "AP",
                value: "AP",
            },
            {
                label: "AM",
                value: "AM",
            },
            {
                label: "BA",
                value: "BA",
            },
            {
                label: "CE",
                value: "CE",
            },
            {
                label: "DF",
                value: "DF",
            },
            {
                label: "ES",
                value: "ES",
            },
            {
                label: "GO",
                value: "GO",
            },
            {
                label: "MA",
                value: "MA",
            },
            {
                label: "MT",
                value: "MT",
            },
            {
                label: "MS",
                value: "MS",
            },
            {
                label: "MG",
                value: "MG",
            },
            {
                label: "PA",
                value: "PA",
            },
            {
                label: "PB",
                value: "PB",
            },
            {
                label: "PR",
                value: "PR",
            },
            {
                label: "PE",
                value: "PE",
            },
            {
                label: "PI",
                value: "PI",
            },
            {
                label: "RJ",
                value: "RJ",
            },
            {
                label: "RN",
                value: "RN",
            },
            {
                label: "RS",
                value: "RS",
            },
            {
                label: "RO",
                value: "RO",
            },
            {
                label: "RR",
                value: "RR",
            },
            {
                label: "SC",
                value: "SC",
            },
            {
                label: "SP",
                value: "SP",
            },
            {
                label: "SE",
                value: "SE",
            },
            {
                label: "TO",
                value: "TO",
            },
          ];
        
        return (
            <AuthenticatedTemplate title="Alterar Endereço">
                <Grid.Row>
                    <Grid.Col md="7">
                        <form method="POST" onSubmit={this.submitHandler} autoComplete="off">
                            <Card>
                                <Card.Body>
                                    <CardAlert color={this.state.alertColor} >{this.state.alertText}</CardAlert>
                                    <Dimmer active={this.state.loading} loader={this.state.loading}>
                                        <p className="lead">
                                            Informe o Endereço que você gostaria de utilizar para receber as{' '}
                                            comunicações do Ooppah.
                                        </p>
                                        <Form.Group label="Cep">
                                            <Input
                                                name="zipcode"
                                                type="text"
                                                value={currentAddress.zipCode || null}
                                                onChange={this.onChangeHandler}
                                                disabled={this.state.showLoader}
                                            />
                                        </Form.Group>

                                        <Form.Group label="Logradouro">
                                            <Input
                                                name="address"
                                                type="text"
                                                value={currentAddress.street || null}
                                                required
                                                onChange={this.onChangeHandler}
                                                disabled={this.state.showLoader}
                                            />
                                        </Form.Group>

                                        <Form.Group label="Número">
                                            <Input
                                                name="number"
                                                type="text"
                                                value={currentAddress.number || null}
                                                onChange={this.onChangeHandler}
                                                disabled={this.state.showLoader}
                                            />
                                        </Form.Group>

                                        <Form.Group label="Complemento">
                                            <Input
                                                name="complement"
                                                type="text"
                                                value={currentAddress.complement || null}
                                                onChange={this.onChangeHandler}
                                                disabled={this.state.showLoader}
                                            />
                                        </Form.Group>

                                        <Form.Group label="Estado">
                                            <select style = {{
                                                width: '100%',
                                                padding: "0.375rem 0.75rem",
                                                fontSize: "0.9375rem",
                                                lineHeight: "1.6",
                                                
                                            }} 
                                            name="state" defaultValue={currentAddress.state || null} onChange={(e) => this.onChangeHandler(e)} disabled={this.state.showLoader}>
                                                {options.map((option) => (
                                                    <option value={option.value}>{option.label}</option>
                                                ))}
                                            </select>
                                        </Form.Group>

                                        <Form.Group label="Cidade">
                                            <Input
                                                name="city"
                                                type="text"
                                                value={currentAddress.city || null}
                                                onChange={this.onChangeHandler}
                                                disabled={this.state.showLoader}
                                            />
                                        </Form.Group>

                                        <Form.Group label="Bairro">
                                            <Input
                                                name="district"
                                                type="text"
                                                value={currentAddress.district || null}
                                                onChange={this.onChangeHandler}
                                                disabled={this.state.showLoader}
                                            />
                                        </Form.Group>

                                        <Button
                                            outline={!this.state.showLoader}
                                            color="info"
                                            block size="lg"
                                            className="mt-6"
                                            loading={this.state.showLoader}
                                            disabled={this.state.showLoader}
                                        >
                                            Alterar meu Endereço
                                        </Button>
                                    </Dimmer>
                                </Card.Body>
                            </Card>
                        </form>
                    </Grid.Col>
                </Grid.Row>
            </AuthenticatedTemplate>
        );
    }
}

export default ChangeAddress;
